<template>
  <div v-if="isDetail && info" class="college-bg prelative ofhidden">
    <div class="lbg pabsolute"></div>
    <div class="htmldiv fs0">
      <div class="txt fs14 twhite dinline-block vtop">
        <div class="fbold fs40 mt40 mb20">{{info.name}}</div>
        <div>
          <span class="mr20">年限：{{info.years}}年</span>
          <span> 层次：{{info.theme_name}}</span>
        </div>
      </div>
      <div class="rbg dinline-block vtop prelative">
        <div class="pimg pabsolute">
          <img class="img" :src="info.background_img">
          <img class="xie pabsolute" src="../../../assets/images/clist_03_01.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "bannerbf",
    props: [
      'isDetail',
      'info',
    ]
  }
</script>

<style scoped>
  .college-bg{height: 220px;background: #063674; /* url(../images/index_03_04.jpg) no-repeat top right*/}
  .college-bg.cblue,.college-bg.cblue .lbg,.college-bg.cblue .txt{background-color: #063674;}
  .college-bg.ccoffee,.college-bg.ccoffee .lbg,.college-bg.ccoffee .txt{background-color: #b0782b;}
  .college-bg .lbg{z-index: 2;left: 0;width: calc(50% - 640px);height: 100%;background: #063674;}
  .college-bg .rbg{/*width: 305px;*/height: 220px;}
  .college-bg .rbg .img{height: 220px;}
  .college-bg .rbg .pimg{position: absolute;left: 0;top: 0;}
  .college-bg .rbg .xie{left: 0;top:0;}
  .college-bg .igs img{height: 80px; }
  .college-bg .txt{z-index: 3;padding-left: 30px;height: 220px;background: #063674;}
</style>



// WEBPACK FOOTER //
// src/components/aedu/professional/bannerbf.vue